import { render, staticRenderFns } from "./Monetization.vue?vue&type=template&id=551ac17c&scoped=true&"
import script from "./Monetization.vue?vue&type=script&lang=js&"
export * from "./Monetization.vue?vue&type=script&lang=js&"
import style0 from "./Monetization.vue?vue&type=style&index=0&id=551ac17c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ac17c",
  null
  
)

export default component.exports